import { Form, InputNumber } from "antd";
import { Controller } from "react-hook-form";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  InfoIconOutlined,
} from "../../CustomIcons";

// interface InputNumberProps<T extends FieldValues> {
//   fieldName: Path<T>;
//   label?: string;
//   control: Control<T>;
//   defaultValue?: PathValue<T, Path<T>> | undefined;
//   iProps?: React.InputHTMLAttributes<HTMLInputElement>;
//   isRequired?: boolean;
//   rules?: object;
//   validate?: "" | "success" | "warning" | "error" | "validating" | undefined;
//   validMessage?: string | React.ReactNode;
//   className?: string;
//   tooltipTitle?: string | React.ReactNode; // Use ReactNode for tooltip title
//   optionalLabel?: string;
//   hintMessage?: string;
//   warning?: boolean;
//   price?: boolean;
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InputNumberField = (props: any) => {
  const {
    fieldName,
    isRequired = false, // Provide default value
    label,
    validMessage,
    className,
    control,
    defaultValue, // Provide default value
    rules,
    iProps,
    tooltipTitle,
    optionalLabel,
    hintMessage,
    warning,
    validate,
    price,
    onInputChange,
  } = props;
  return (
    <Form.Item
      required={isRequired}
      label={<div className="label_text">{label}</div>}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          placement: "topLeft",
          arrow: false,
          icon: <InfoIconOutlined />,
        }
      }
    >
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <InputNumber
                value={
                  typeof value === "number"
                    ? value
                    : typeof value === "string"
                    ? parseFloat(value)
                    : undefined
                }
                autoComplete="new-state"
                onChange={(val) => {
                  onChange(val ?? null);
                  onInputChange && onInputChange(val);
                }} // Ensure `onChange` gets a number | undefined
                formatter={(val) => {
                  if (!price) return `${val ?? ""}`;
                  const [intPart, decPart] = String(val ?? "").split(".");
                  const intWithCommas = intPart.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  );
                  return decPart !== undefined
                    ? `${intWithCommas}.${decPart}`
                    : intWithCommas;
                }}
                // formatter={(val) =>
                //   price
                //     ? `${val}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                //     : `${val}`
                // }
                parser={(val) =>
                  price ? val?.replace(/\$\s?|(,*)/g, "") || "" : val || ""
                }
                controls={{
                  upIcon: <ArrowUpIcon />,
                  downIcon: <ArrowDownIcon style={{ color: "#151718" }} />,
                }}
                min={0}
                max={999999999}
                {...iProps}
                precision={3}
              />
              {optionalLabel && (
                <div className="optional-label">{optionalLabel}</div>
              )}
              {hintMessage && (
                <div
                  className={
                    warning ? "hint-label warning-label" : "hint-label"
                  }
                >
                  {hintMessage}
                </div>
              )}
            </>
          );
        }}
      />
    </Form.Item>
  );
};
